{
  "pricing": {
    "loadingInfo": "Carregando informações de preços...",
    "noPriceInfo": "Nenhuma informação de preço disponível",
    "takeGoldmakingNextLevel": "Leve sua geração de ouro para o próximo nível",
    "subscribeFrom": "Assine por apenas {{price}} {{currency}} / mês. Sem compromisso. Cancele quando quiser.",
    "goldSubActive": "Sua assinatura {{type}} atual vai até {{expiration}}",
    "goldSubTitle": "Assinatura Gold ativa",
    "goldSubUpgradeTitle": "Pronto para o Premium?",
    "goldSubHeading": "Bem-vindo de volta, fabricante de ouro",
    "goldSubHeadingSubtitle": "Obrigado por ser um membro Gold — aqui está sua assinatura em resumo.",
    "upgradeToPremiumContact": "Para atualizar para premium entre em contato com nossa equipe no",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Gerenciar faturamento e métodos de pagamento",
    "manageBillingOpening": "Abrindo...",
    "monthly": "Mensal",
    "yearly": "Anual",
    "saveUpTo": "Economize até {{percent}}% com uma assinatura anual.",
    "mostPopular": "Mais popular",
    "perMonth": "/mês",
    "perYear": "/ano",
    "startDate": "Data de início: {{date}}",
    "nextPaymentDate": "Próxima data de pagamento: {{date}}",
    "subscriptionEnds": "Assinatura termina: {{date}}",
    "reasonPaymentFailed": "Motivo: Pagamento falhou",
    "reasonCancelled": "Motivo: Cancelado",
    "accessTools": "Acessar as ferramentas",
    "resumeSubscription": "Retomar assinatura",
    "cancelSubscription": "Cancelar assinatura",
    "processing": "Processando...",
    "subscribeNow": "Assinar agora",
    "getStarted": "Começar",
    "switchToMonthly": "Mudar para mensal",
    "switchToYearly": "Mudar para anual",
    "upgradeToPremium": "Atualizar para Premium",
    "upgradeLabel": "Atualizar para Premium ({{billing}})",
    "downgradeToBasic": "Fazer downgrade para Basic",
    "downgradeLabel": "Fazer downgrade para Basic ({{billing}})",
    "switchPlan": "Mudar plano",
    "currentPlan": "Plano atual",
    "statusActive": "Ativo",
    "statusExpired": "Expirado",
    "statusCanceled": "Cancelado",
    "statusInCancelation": "Em cancelamento",
    "showMoreFeatures": "+ {{count}} mais recursos",
    "showFewerFeatures": "Mostrar menos"
  },
  "trial": {
    "activatedTitle": "Teste ativado!",
    "activatedSubtitle": "Veja o que você recebe — e o que está esperando por você",
    "startExploring": "Começar a explorar",
    "viewPlans": "Ver planos",
    "trialActive": "Teste gratuito ativo",
    "daysRemaining": "{{count}} dia restante",
    "expires": "Expira em {{date}}",
    "trialLabel": "Teste",
    "compareButton": "Comparar planos",
    "trialEnded": "Seu teste gratuito terminou. Assine acima para continuar usando o FlippingPal!",
    "haveTrialCode": "Tem um código de teste?",
    "trialCodeHint": "Use",
    "trialCodeHint2": "no nosso",
    "discordServer": "servidor Discord",
    "trialCodeHint3": "para obter um",
    "activateButton": "Ativar teste",
    "activatingButton": "Ativando"
  },
  "features": {
    "basic": {
      "0": "Limitado a 10 reinos de venda",
      "1": "Ferramenta de housing para flip e dropship de decoração",
      "2": "Ferramenta de flipping entre reinos",
      "3": "Ferramenta de dropship limitada a 3 resultados por item",
      "4": "Estatísticas do reino",
      "5": "Gerador de listas TSM",
      "6": "Até 50 alertas de snipe para Discord",
      "7": "Presets de filtros limitados a 3",
      "8": "Suporte ao cliente da equipe"
    },
    "premium": {
      "0": "Reinos de venda ilimitados",
      "1": "Ferramenta de housing para flip e dropship de decoração",
      "2": "Ferramenta de flipping entre reinos",
      "3": "Ferramenta de dropship aumentada para 10 resultados por item",
      "4": "Estatísticas do reino",
      "5": "Gerador de listas TSM",
      "6": "Ferramenta de análise de inventário",
      "7": "Até 9999 alertas de snipe para Discord",
      "8": "Presets de filtros limitados a 50",
      "9": "Compartilhamento de filtros com função de importação/exportação",
      "10": "Suporte ao cliente da equipe",
      "11": "Suporte prioritário"
    }
  },
  "loading": "Carregando informações de assinatura..."
}
